import { render, staticRenderFns } from "./IsRehousingNeededQuestion.vue?vue&type=template&id=4d3279de&scoped=true"
import script from "./IsRehousingNeededQuestion.vue?vue&type=script&lang=ts"
export * from "./IsRehousingNeededQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3279de",
  null
  
)

export default component.exports